module.exports = __webpack_public_path__ + "assets/images/okenki-20c2275ae697bd139fa462e1ba69708b.png";